import { render, staticRenderFns } from "./NavToggle.vue?vue&type=template&id=48b54b14&scoped=true"
import script from "./NavToggle.vue?vue&type=script&lang=js"
export * from "./NavToggle.vue?vue&type=script&lang=js"
import style0 from "./NavToggle.vue?vue&type=style&index=0&id=48b54b14&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b54b14",
  null
  
)

export default component.exports